import { NgModule } from '@angular/core';

import { LoanCarScheduleActionsComponent } from './loan.car.actions.component';
import { LoanCarScheduleStatusPipe }       from './loan-car-schedule.status.pipe';
import { LoanCarService }                  from './loan-car.service';
import { LoanCarVehicleComponent }         from './loan-car.vehicle.component';
import { SharedModule }                    from '../shared/shared.module';

@NgModule({
  declarations: [
    LoanCarScheduleActionsComponent,
    LoanCarScheduleStatusPipe,
    LoanCarVehicleComponent
  ],
  entryComponents: [
    LoanCarScheduleActionsComponent,
    LoanCarVehicleComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    LoanCarScheduleStatusPipe,
    LoanCarService,

    // Pipes must also be provided via string
    // if they are going to be used in a table
    // column. This allows the injector to be
    // able to load a pipe dynamically in the
    // TableCellComponent.
    {
      provide : 'loanStatus',
      useClass: LoanCarScheduleStatusPipe
    }
  ]
})
export class LoanCarScheduleModule {}